import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type JivoCredentialsResponse as SchemaJivoCredentialsResponse } from '../schemas/JivoCredentialsResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetJivoCredentialsContentType = '' as const;
export type GetJivoCredentialsRequest = void;
export type GetJivoCredentialsResponses = LinkCommonErrorResponses & {
    /**
     * @description Jivo URL retrieved successfully
     */
    '200': {
        'application/json': SchemaJivoCredentialsResponse;
    };
};
export type GetJivoCredentialsResponseSuccess = GetJivoCredentialsResponses['200']['application/json'];
export type GetJivoCredentialsSearchParams = undefined;
export type GetJivoCredentialsPathParameters = undefined;
export const GetJivoCredentialsUrl = '/integrations/jivo/credentials' as const;
export const GetJivoCredentialsMethod = 'GET' as const;
export const getGetJivoCredentialsUrl = (_params?: GetJivoCredentialsPathParameters) => GetJivoCredentialsUrl;
